import $ from 'jquery';
import Widgets from 'js-widget-hooks';
import React from 'react';
import ReactDOM from 'react-dom';
import VideoWidget from '../modules/VideoWidget.jsx';

/** @type {Node} el */
Widgets.register('video', function(el){

    let elem = $(el),
        config = elem.data('config'),
        placeholder_image = { src: elem.find('img').attr('src') }
    ;

    ReactDOM.render( <VideoWidget src={config.url} placeholder_image={placeholder_image} />, el);
});